import React from 'react';
import CloneAccountCard from '../../Accounts/AccountCreationWorkflow/AccountTypeSelection/CloneAccountCard';
import PreDefinedAccountTypeCard from '../../Accounts/AccountCreationWorkflow/AccountTypeSelection/PreDefinedAccountTypeCard';
import RegistrationBrandingCard from '../../Accounts/AccountCreationWorkflow/Branding/RegistrationBrandingCard';
import RegistrationCard from '../../Accounts/AccountCreationWorkflow/Registration/RegistrationCard';
import OrganizationDetailsCard from '../../Accounts/AccountCreationWorkflow/OrganizationDetailsCard/OrganizationDetailsCard';
import DragDropZone from '../../Accounts/AccountCreationWorkflow/DragDropZone/DragDropZone';
import NACSideBar from '../../Accounts/AccountCreationWorkflow/SideBar/NACSideBar';
import NavigationWidget from '../../Accounts/AccountCreationWorkflow/NavigationWidget/NavigationWidget';
import MobileDesktopPreviewToggle from '../../Accounts/AccountCreationWorkflow/MobileDesktopPreviewToggle/MobileDesktopPreviewToggle';
import ProgressRing from '../../Charts//ProgressRing';

export default function AccountPlaygroundPage(props) {
	console.log('AccountPlayground', props);
	return (
		<div>
			<PreDefinedAccountTypeCard
				data={[
					'foo',
					'bar',
					'baz',
					'qux',
					'fred',
					'thud'
				]}
			/>
			<CloneAccountCard />
			<RegistrationBrandingCard
				data={[
					{ name: 'First Name', type: 'text' },
					{ name: 'Last Name', type: 'text' },
					{ name: 'Month', type: 'text' },
					{ name: 'Day', type: 'text' },
					{ name: 'Year', type: 'text' },
					{ name: 'Phone number', type: 'phone' },
					{ name: 'Email address', type: 'text' },
					{ name: 'Opt-in', type: 'radio' }
				]}
			/>
			<DragDropZone />
			<NavigationWidget icon="fa fa-book" label="Organization Details" />
			<NACSideBar title="New Account Steps" />
			<OrganizationDetailsCard />
			<RegistrationCard />
			<ProgressRing percentage={15} />
			<ProgressRing percentage={35} />
			<ProgressRing percentage={55} />
			<ProgressRing percentage={68} />
			<ProgressRing percentage={92} />
		</div>
	);
}
